import { RouteInfo } from './sidebar.metadata'
export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'Menú Principal',
    moduleName: '',
    iconType: '',
    icon: '',
    class: '',
    groupTitle: true,
    badge: '',
    badgeClass: '',
    role: ['All'],
    submenu: []
  },

  // Admin Modules
  {
    path: '/intranet/dashboard',
    title: 'Tablero Intranet',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin'],
    submenu: []
  },
  {
    path: '',
    title: 'Catálogos',
    moduleName: 'catalogos',
    iconType: 'material-icons-two-tone',
    icon: 'category',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin'],
    submenu: [
      {
        path: '/catalogos/medicos',
        title: 'Médicos',
        moduleName: 'catalogos',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: []
      },
      {
        path: '/catalogos/empresas',
        title: 'Empresas',
        moduleName: 'catalogos',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: []
      },
      {
        path: 'catalogos/representantes',
        title: 'Representantes',
        moduleName: 'catalogos',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: []
      },
      {
        path: 'catalogos/intranet',
        title: 'Intranet',
        moduleName: 'catalogos',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: []
      },
      {
        path: '/catalogos/sucursales',
        title: 'Sucursales',
        moduleName: 'catalogos',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Aplicación',
    moduleName: 'aplicacion',
    iconType: 'material-icons-two-tone',
    icon: 'app_settings_alt',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Admin'],
    submenu: [

      {
        path: '/aplicacion/app-contenido',
        title: 'App Contenido',
        moduleName: 'aplicacion',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: []
      },
      {
        path: '/aplicacion/whatsapp',
        title: 'WhatsApp Config',
        moduleName: 'aplicacion',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: ['Admin'],
        submenu: []
      }
    ]
  },
  // Doctor Modules
  {
    path: '/medicos/dashboard',
    title: 'Tablero Médico',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Doctor'],
    submenu: []
  },
  {
    path: '/medicos/resultados',
    title: 'Resultados',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'description',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Doctor'],
    submenu: []
  },

  // Empresas Modules
  {
    path: '/empresas/dashboard',
    title: 'Tablero Empresas',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Empresas'],
    submenu: []
  },
  {
    path: '/empresas/resultados',
    title: 'Resultados',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'description',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Empresas'],
    submenu: []
  },

  // Patient Modules
  {
    path: '/pacientes/dashboard',
    title: 'Tablero Paciente',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'space_dashboard',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Paciente'],
    submenu: []
  },
  {
    path: '/pacientes/resultados',
    title: 'Resultados',
    moduleName: 'dashboard',
    iconType: 'material-icons-two-tone',
    icon: 'description',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['Paciente'],
    submenu: []
  },
  // Common Modules

  {
    path: '',
    title: 'Extra Pages',
    moduleName: 'extra-pages',
    iconType: 'material-icons-two-tone',
    icon: 'description',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['AdminOK'],
    submenu: [
      {
        path: '/extra-pages/blank',
        title: 'Blank Page',
        moduleName: 'extra-pages',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: []
      }
    ]
  },
  {
    path: '',
    title: 'Multi level Menu',
    moduleName: 'multilevel',
    iconType: 'material-icons-two-tone',
    icon: 'slideshow',
    class: 'menu-toggle',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    role: ['AdminOK'],
    submenu: [
      {
        path: '/multilevel/first1',
        title: 'First',
        moduleName: 'multilevel',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: []
      },
      {
        path: '/',
        title: 'Second',
        moduleName: 'secondlevel',
        iconType: '',
        icon: '',
        class: 'ml-sub-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: [
          {
            path: '/multilevel/secondlevel/second1',
            title: 'Second 1',
            moduleName: 'secondlevel',
            iconType: '',
            icon: '',
            class: 'ml-sub-sub-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            role: [''],
            submenu: []
          },
          {
            path: '/multilevel/secondlevel/second2',
            title: 'Second 2',
            moduleName: 'secondlevel',
            iconType: '',
            icon: '',
            class: 'ml-sub-sub-menu',
            groupTitle: false,
            badge: '',
            badgeClass: '',
            role: [''],
            submenu: []
          }
        ]
      },
      {
        path: '/multilevel/first3',
        title: 'Third',
        moduleName: 'multilevel',
        iconType: '',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        badge: '',
        badgeClass: '',
        role: [''],
        submenu: []
      }
    ]
  }
]
